var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8463",
    "data-name": "Group 8463",
    transform: "translate(0 0.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 20,
    height: 20,
    transform: "translate(0 -0.198)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(1.583 0.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1751.355,967.764h-4.85v5.286h4.85a.374.374,0,0,0,.374-.374v-4.538A.374.374,0,0,0,1751.355,967.764Z",
    transform: "translate(-1737.545 -956.23)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1712.933,968.137v4.538a.374.374,0,0,0,.374.374h4.85v-5.286h-4.85A.374.374,0,0,0,1712.933,968.137Z",
    transform: "translate(-1710.229 -956.23)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1726.516,939.14h5.813a.374.374,0,0,0,.374-.374v-4.538a.374.374,0,0,0-.374-.374h-2.39v2.169a.516.516,0,0,1-1.033,0v-2.169h-2.39a.374.374,0,0,0-.374.374v4.538A.374.374,0,0,0,1726.516,939.14Z",
    transform: "translate(-1720.977 -928.639)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1699.9,922.73a.721.721,0,0,0,.008-.081v-10.3l6.982-4.826,6.925,4.824v10.3a.721.721,0,0,0,.008.081h1.474a.751.751,0,0,0,.008-.081V911.957a.745.745,0,0,0-.319-.612L1707.321,906a.745.745,0,0,0-.85,0l-7.729,5.342a.745.745,0,0,0-.321.613v10.692a.721.721,0,0,0,.008.081Z",
    transform: "translate(-1698.42 -905.869)",
    fill: "#5475c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorInventory);
export default __webpack_public_path__ + "static/media/color_inventory.99b910ed4405e312bd1e3318d119362d.svg";
export { ForwardRef as ReactComponent };